<template>
  <div>
    <router-link-blank v-if="isDetail"
              classMessage="has-text-weight-bold lien mgr-5px"
              :to="{ name: 'c.bodac.clients/contacts-client',
                params: { id: tiers.id }}"
              :message="tiers.nomCommercial"/>
    <p class="has-text-link has-text-weight-bold is-size-6" v-else>
      {{ tiers.nomCommercial }}
    </p>
    <niveau-blocage-icone
      v-if="tiers.blocageLevel"
      :niveau="tiers.blocageLevel"
      :description="tiers.descriptionBlocage"
      size="is-small"/>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import niveauBlocageIcone from './NiveauBlocageIcone';

export default {
  props: {
    tiers: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    routerLinkBlank,
    niveauBlocageIcone,
  },
};
</script>

<style>

</style>
